/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

/*
 * Get and set the current account in context. This is used by xhr to add the account context to requests.
 */
exports.get = function () {
  return this.account;
};
exports.set = function (account) {
  this.account = account;
};